import type { FunctionComponent, PropsWithChildren } from 'react';
import useSubscriptionPlanPrices from '../../hooks/useSubscriptionPlanPrices';
import { LEARN_MORE } from '../../utils/legalUrls';
import { Plans } from '../constants';
import OptionButtons from './OptionButtons';
import PerksList from './PerksList';
import TrialUpgradeDisclaimer from './TrialUpgradeDisclaimer/TrialUpgradeDisclaimer';

type MobileLayoutProps = {
  handleChange: () => void;
  selected: string;
  onClickUpgrade: () => void;
  showAdditionalPerks: boolean;
};

const MobileLayout: FunctionComponent<PropsWithChildren<MobileLayoutProps>> = ({
  handleChange = () => null,
  selected = Plans.SEASONAL,
  onClickUpgrade,
  showAdditionalPerks = false,
  children,
}) => {
  const { seasonalPrice, annualPrice } = useSubscriptionPlanPrices();
  const displayPerks = annualPrice && seasonalPrice;

  return (
    <div data-testid="ml-trial-container" className="trial-container">
      <div data-testid="ml-title-container" className="title-container">
        <h2>Start Today</h2>
        <h4>Pick your plan below</h4>
      </div>
      <div data-testid="ml-trial-buttonContainer" className="trialButtonContainer">
        <OptionButtons handleChange={handleChange} selected={selected} />
      </div>
      <div data-testid="ml-trial-list-container" className="trialListContainer">
        {displayPerks && (
          <PerksList
            selected={selected}
            showAdditionalPerks={showAdditionalPerks}
            annualPrice={annualPrice}
            seasonalPrice={seasonalPrice}
          />
        )}
      </div>
      <TrialUpgradeDisclaimer selected={selected} />
      <div className="textCenter w-90 margin-0-auto">
        <button
          data-testid="ml-confirm-purchase"
          type="button"
          className="btn btnLg btnCta"
          onClick={() => onClickUpgrade()}
        >
          CONFIRM PURCHASE
        </button>
        {children}
      </div>
      <p data-testid="ml-trial-notice" className="trial-notice my-15">
        *Additional $8/box shipping for Canada, Hawaii, Alaska, and Puerto Rico. Sales tax may apply
        (
        <a href={LEARN_MORE} target="_blank" rel="noreferrer">
          learn more
        </a>
        ).
      </p>
    </div>
  );
};

export default MobileLayout;
